export function localeCompareIgnoreCase(a: string | undefined | null, b: string | undefined | null): number {
	return (a ?? "").toLowerCase().localeCompare((b ?? "").toLowerCase());
}